import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function GotoTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
  }, [pathname]);

  return null;
}



// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export default function GotoTop() {
//   const routePath = useLocation();

//   useEffect(() => {
//     // reset to top immediately when route changes
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "auto", // use "auto" if browser doesn’t support "instant"
//     });
//   }, [routePath]);

//   return null;
// }
